import { ref, watch } from 'vue';
import { tableList } from '../services/optilogicService';

/**
 * Composable for managing table selection based on selected model
 * Shared between GetTableData and GeocodeData components
 */
export function useTableSelection(props) {
    const selectedTable = ref('');
    const tables = ref([]);

    const fetchTableList = async (modelName) => {
        console.log(`call fetchTableList with ${modelName}`);
        if (modelName) {
            const tableData = await tableList(modelName);
            tables.value = tableData;
            console.log(`fetched tables for ${modelName}`);
            console.log('table list: ', tables.value);
        }
    };

    // Watch for model changes and fetch tables
    // Handle both regular props and computed props
    watch(
        () => {
            // If props is a computed ref, access its value
            const propsValue = props.value ? props.value : props;
            return propsValue.selectedModel;
        },
        async (newModel) => {
            if (newModel) {
                console.log("watch triggered for selectedModel:", newModel);
                await fetchTableList(newModel.id);
            }
        },
        { immediate: true }
    );

    return {
        selectedTable,
        tables,
        fetchTableList
    };
}
